export default __webpack_public_path__ + "static/media/diabetescare.2ae263ec.jpg";